import Vue from "vue";
import App from "./App.vue";
import vuetify from "./plugins/vuetify";
import router from "./router";
import store from "./store";
import VueYouTubeEmbed from "vue-youtube-embed";
import VueSocialSharing from "vue-social-sharing";
import Meta from "vue-meta";
import VueYandexMetrika from 'vue-yandex-metrika'
import LottieAnimation from 'lottie-web-vue'

Vue.use(VueYouTubeEmbed);
Vue.use(VueSocialSharing);
Vue.use(Meta);
Vue.use(VueYandexMetrika, {
  id: 66631075,
  router: router,
  env: process.env.NODE_ENV
  // other options
})
Vue.use(LottieAnimation);

Vue.config.productionTip = false;

export const eventEmitter = new Vue();

router.afterEach((to) => {
  Vue.nextTick(() => {
    if (to.meta.title) {
      document.title = to.meta.title;
    }
  });
});

new Vue({
  components: {},
  vuetify,
  router,
  store,
  render: (h) => h(App),
}).$mount("#app");
